import { api, LightningElement } from "lwc";
import type { RoleCollectionSummary } from "./types";
export type { RoleCollectionSummary };


export default class RoleCollection extends LightningElement {
    static renderMode = "light";
    @api summary: RoleCollectionSummary = null!;

    private get hasRoleCollectionSummary() {
        return this.summary !== null;
    }
}